import invariant from 'invariant'
import { ApiError, RequestError, InternalError } from '../../services/request/errors'

import { CLIENT, SERVICE_UNAVAILABLE } from './constants'
import defaultMessages from './messages'

function getMessage(key, messages = {}) {
  const message = messages[key] || defaultMessages[key]

  invariant(
    message != null,
    `Could not find ${key} in provided exception messages or defaultMessages, ` +
    `please make sure to include ${key} in provided messages`
  )

  return message
}

export function getExceptionMessage(exception, messages) {
  if (typeof exception.is === 'function') {
    if (exception.is(InternalError)) {
      return getMessage(CLIENT, messages)
    }
    if (exception.is(RequestError)) {
      return getMessage(SERVICE_UNAVAILABLE, messages)
    }
    if (exception.is(ApiError)) {
      return getMessage(exception.errorCode, messages)
    }
  }

  return getMessage(CLIENT, messages)
}
